import React from "react";
import styled from "styled-components";

// assets
import iconLoading from "assets/icons/icon_loading.gif";

const Loading = () => {
  return <Wrapper />;
};

export default Loading;

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.3) url(${iconLoading}) no-repeat center
    center / 50px;
`;
